// What kind of device the app is running on (for wording and the iPhone alerts rules).
const ua = navigator.userAgent;
export const isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isStandalone =
  matchMedia('(display-mode: standalone)').matches ||
  (navigator as Navigator & { standalone?: boolean }).standalone === true;
export const deviceLabel = isIOS
  ? /iPad/.test(ua)
    ? 'iPad'
    : 'iPhone'
  : /Mac/.test(navigator.platform)
    ? 'Mac'
    : 'Computer';
